import {Location} from 'history'
import React, {useEffect, useState} from 'react'
import {Prompt} from 'react-router-dom'

interface RouteLeavingGuardType {
	when?: boolean | undefined
	navigate: (path: string) => void
	shouldBlockNavigation: (nextLocation: Location) => boolean
	disableExternalNavigationBlocking?: boolean
}
export const RouteLeavingGuard: React.FC<RouteLeavingGuardType> = ({
	when,
	navigate,
	shouldBlockNavigation,
	disableExternalNavigationBlocking,
	children
}) => {
	const [modalVisible, setModalVisible] = useState(false)
	const [lastLocation, setLastLocation] = useState<Location | null>(null)
	const [confirmedNavigation, setConfirmedNavigation] = useState(false)

	useEffect(() => {
		if (confirmedNavigation && lastLocation) {
			// Navigate to the previous blocked location with your navigate function
			navigate(lastLocation.pathname)
		}

		if (shouldBlockNavigation && !disableExternalNavigationBlocking) {
			window.onbeforeunload = () => true
		} else {
			window.onbeforeunload = undefined
		}
	}, [confirmedNavigation, lastLocation])

	const handleBlockedNavigation = (
		nextLocation: Location
	): string | boolean => {
		if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
			setModalVisible(true)
			setLastLocation(nextLocation)
			return false
		}
		return true
	}

	return (
		<>
			<Prompt when={when} message={handleBlockedNavigation} />
			{typeof children === 'function'
				? children({setModalVisible, modalVisible, setConfirmedNavigation})
				: children}
		</>
	)
}
